import { Box, Chip, Paper, Tooltip, Typography } from '@mui/material';
import { action, makeObservable, runInAction, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/cabecalho.css';
import ReactComponent from '../ReactComponent';

class FiltrosAtivos extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            handleDeleteValor: action,
            handleDeleteValorArray: action
        });
    }

    handleDeleteValor = (filtro) => {
        this.store.alterandoValorFiltro = true;
        setTimeout(
            () =>
                runInAction(() => {
                    filtro.valor = undefined;
                    this.store.alterandoValorFiltro = false;
                }),
            10
        );
    };

    handleDeleteValorArray = (filtro, valor) => {
        this.store.alterandoValorFiltro = true;
        setTimeout(
            () =>
                runInAction(() => {
                    let valores = filtro.valor.filter((valorArray) => valorArray !== valor);
                    filtro.valor = valores.length > 0 ? valores : undefined;
                    this.store.alterandoValorFiltro = false;
                }),
            10
        );
    };

    render() {
        if (!this.store.filtros.existeFiltroComValor) {
            return null;
        }
        return (
            <Paper
                elevation={4}
                style={{ margin: '5px', minHeight: '34px', maxHeight: '65px', overflowY: 'auto' }}
            >
                <Box style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', flexGrow: '1' }}>
                    <Typography style={{ margin: '0px 5px 0px 10px', color: 'darkorange', fontWeight: 'bold' }}>
                        {`Filtros ativos: `}
                    </Typography>
                    {this.store.filtros.filtrosComValor.map((filtro) =>
                        !filtro.ocultaValoresChipFiltroAtivo && Array.isArray(toJS(filtro.valor))
                            ? filtro.valor.map((valorArray) =>
                                  this.renderChip(filtro, valorArray, () =>
                                      this.handleDeleteValorArray(filtro, valorArray)
                                  )
                              )
                            : this.renderChip(filtro, filtro.valor, () => this.handleDeleteValor(filtro))
                    )}
                </Box>
            </Paper>
        );
    }

    renderChip(filtro, valor, funcaoDelete) {
        const descricaoChip =
            filtro.label + (!filtro.ocultaValoresChipFiltroAtivo ? ': ' + filtro.getDescricao(valor) : '');

        return (
            <Tooltip
                key={this.nextKey}
                placement="top"
                title={descricaoChip}
            >
                <Box>
                    <Chip
                        label={descricaoChip}
                        style={{
                            maxWidth: '400px',
                            height: '26px',
                            margin: '3px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                        onDelete={funcaoDelete}
                    />
                </Box>
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(FiltrosAtivos));
